@if (steps().length) {
    <ol class="flex flex-row flex-wrap">
        @for (step of steps(); let index = $index; let last = $last; track index) {
            <tran-step-tile class="!pb-6" [tile]="step" [stepPrefix]="stepPrefix()" [isLast]="last" />
        }
    </ol>
}
